import { useMediaQuery } from '@mui/material';

/**
 * Whether the user has asked the system to reduce motion.
 *
 * jsdom reports no match for any media query, so tests have to stub
 * `matchMedia` to exercise the "reduce" branch -- see `stubBreakpoint` in the
 * chat tests. Left unstubbed this reports false, which is the reduced-motion-off
 * path and therefore the one the rest of the suite runs against.
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)', {
    // No matchMedia, no motion preference. Treating "unknown" as "animate"
    // keeps behaviour identical to not checking at all.
    noSsr: false,
    defaultMatches: false,
  });
}
